import React from "react";
import { Link } from "react-router-dom";

export default function SingleServiceHero({ service }) {
  return (
    <header className="single-service-hero">
      <div className="container">
        <nav className="track-breadcrumb">
          <Link to="/services">Services</Link>
          <span>/</span>
          <span className="current">{service.title}</span>
        </nav>

        <div className="row g-4 align-items-center">
          <div className="col-lg-7">
            <div className="service-card-icon mb-3"></div>
            <h1 className="single-service-title">{service.title}</h1>
            <p className="single-service-desc">{service.desc}</p>
            <div className="d-flex gap-3 flex-wrap">
              <a href="#pricing" className="btn-mu-solid">
                Get Started &mdash; From {service.price}
              </a>
              <Link to="/services" className="btn-mu-outline">+ All Services</Link>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="single-service-image">
              <img src={service.heroImage} alt={service.title} />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
